import { Component, inject, OnInit } from '@angular/core';
import { SortOrder } from '@modules/common/types/sort-order';
import { MessageListStateService } from '@modules/messages/services/message-list-state.service';
import { MessagesService } from '@modules/messages/services/messages.service';
import { Message } from '@modules/messages/types/message';
import { MessagesFilters } from '@modules/messages/types/messages-filters';
import { MessagesListState } from '@modules/messages/types/messages-list-state';
import { KnowledgeStitchSectionComponent } from '../stitch-section/stitch-section.component';

@Component({
  selector: 'app-knowledge-messages-section',
  templateUrl: './messages-section.component.html',
  styleUrls: ['../stitch-section/stitch-section.component.less'],
  standalone: false,
  providers: [
    ...MessageListStateService.providers({
      defaultSort: {
        by: 'score',
        order: SortOrder.DESC,
      },
    }),
  ],
})
export class KnowledgeMessagesSectionComponent
  extends KnowledgeStitchSectionComponent<Message, MessagesFilters>
  implements OnInit
{
  protected readonly listStateService = inject(MessageListStateService, { self: true });
  protected readonly stitchService = inject(MessagesService);

  public override ngOnInit(): void {
    this.state = new MessagesFilters({ withEmpty: true });
    super.ngOnInit();
  }

  public handleFilter(listState: MessagesListState): void {
    this.filterChange.emit();

    // Read directly, not streamed: handleFilter only runs on a user action, which is always after
    // the space settings have loaded, so the zone is already the account's (SBUX-829).
    this.filters = new MessagesFilters({ displayTimeZone: this.displayTimeZoneService.timeZone() });
    this.filters.applyListState(listState);
    // The knowledge panel has no Conversation View toggle, yet applyListState defaults
    // threadedView to true — which would send mode=threaded and restrict knot results to
    // inbox (incoming/received) messages only. Force it off so knot-filtered results
    // include sent/draft messages across all folders, consistent with the absent toggle.
    this.filters.threadedView = false;

    this.updateFilters();
  }
}
